import { api } from './client';
import type {
  AssignOperatorTeamRequest,
  AuditLogDto,
  AuditQuery,
  CreateOperatorRequest,
  CreateTeamRequest,
  CreateUnitRequest,
  CreateUserRequest,
  OperatorDto,
  ResetPasswordRequest,
  RoleDto,
  TeamDto,
  UnitDto,
  UpdateOperatorRequest,
  UpdateUserRequest,
  UserDto,
} from '../types/admin';

export const usersApi = {
  list: () => api.get<UserDto[]>('/users').then((r) => r.data),
  create: (body: CreateUserRequest) => api.post<UserDto>('/users', body).then((r) => r.data),
  update: (id: number, body: UpdateUserRequest) =>
    api.put<UserDto>(`/users/${id}`, body).then((r) => r.data),
  deactivate: (id: number) => api.post<void>(`/users/${id}/deactivate`).then((r) => r.data),
  activate: (id: number) => api.post<void>(`/users/${id}/activate`).then((r) => r.data),
  resetPassword: (id: number, body: ResetPasswordRequest) =>
    api.post<void>(`/users/${id}/reset-password`, body).then((r) => r.data),
};

export const rolesApi = {
  list: () => api.get<RoleDto[]>('/roles').then((r) => r.data),
};

export const orgApi = {
  listUnits: () => api.get<UnitDto[]>('/units').then((r) => r.data),
  createUnit: (body: CreateUnitRequest) => api.post<UnitDto>('/units', body).then((r) => r.data),
  listTeams: () => api.get<TeamDto[]>('/teams').then((r) => r.data),
  createTeam: (body: CreateTeamRequest) => api.post<TeamDto>('/teams', body).then((r) => r.data),
  listOperators: () => api.get<OperatorDto[]>('/operators').then((r) => r.data),
  createOperator: (body: CreateOperatorRequest) =>
    api.post<OperatorDto>('/operators', body).then((r) => r.data),
  updateOperator: (id: number, body: UpdateOperatorRequest) =>
    api.put<OperatorDto>(`/operators/${id}`, body).then((r) => r.data),
  assignOperatorTeam: (id: number, body: AssignOperatorTeamRequest) =>
    api.put<void>(`/operators/${id}/team`, body).then((r) => r.data),
};

export const auditApi = {
  list: (query: AuditQuery = {}) =>
    api.get<AuditLogDto[]>('/audit', { params: query }).then((r) => r.data),
};
